import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';

export default function Booking() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    date: '',
    time: '',
    device: '',
    problem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const services = [
    'Servis Laptop',
    'Servis HP',
    'Cetak Foto',
    'Desain Grafis',
    'Pasang CCTV',
    'Instalasi PLTS',
    'Servis Sepeda Listrik',
    'Undangan Digital',
    'Lainnya'
  ];

  const timeSlots = [
    '08:00 - 09:00',
    '09:00 - 10:00',
    '10:00 - 11:00',
    '11:00 - 12:00',
    '13:00 - 14:00',
    '14:00 - 15:00',
    '15:00 - 16:00',
    '16:00 - 17:00'
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name || !formData.phone || !formData.service || !formData.date || !formData.time) {
      return;
    }

    if (formData.problem.length > 500) {
      alert('Deskripsi masalah tidak boleh lebih dari 500 karakter');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams({
        name: formData.name,
        phone: formData.phone,
        email: formData.email,
        service: formData.service,
        date: formData.date,
        time: formData.time,
        device: formData.device,
        problem: formData.problem
      }).toString();

      const response = await fetch('https://readdy.ai/api/form/d4hvsqbamli27834gkn0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          email: '',
          service: '',
          date: '',
          time: '',
          device: '',
          problem: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <Header />
      
      <div className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-block mb-4">
              <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-orange-50 px-4 py-2 rounded-full">
                Booking Online
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4">
              Reservasi Jadwal Servis
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Pesan jadwal servis Anda sekarang dan dapatkan pelayanan terbaik
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-3xl shadow-xl border border-gray-200 overflow-hidden">
              {/* Info Banner */}
              <div className="bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] text-white p-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FF8A00] rounded-xl flex-shrink-0">
                    <i className="ri-information-line text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-lg mb-2">Informasi Penting</h3>
                    <ul className="space-y-1 text-sm text-gray-200">
                      <li>• Booking minimal H-1 sebelum jadwal yang dipilih</li>
                      <li>• Kami akan konfirmasi via WhatsApp maksimal 2 jam</li>
                      <li>• Bawa perangkat sesuai jadwal yang sudah dikonfirmasi</li>
                      <li>• Untuk servis mendadak, hubungi langsung via WhatsApp</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Form */}
              <form id="booking-form" onSubmit={handleSubmit} className="p-8" data-readdy-form>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Nama */}
                  <div>
                    <label htmlFor="name" className="block text-sm font-semibold text-[#0B1F3B] mb-2">
                      Nama Lengkap <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                      className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#FF8A00] focus:ring-2 focus:ring-[#FF8A00]/20 outline-none transition-all text-sm"
                      placeholder="Masukkan nama Anda"
                    />
                  </div>

                  {/* Phone */}
                  <div>
                    <label htmlFor="phone" className="block text-sm font-semibold text-[#0B1F3B] mb-2">
                      Nomor WhatsApp <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      required
                      className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#FF8A00] focus:ring-2 focus:ring-[#FF8A00]/20 outline-none transition-all text-sm"
                      placeholder="08xx-xxxx-xxxx"
                    />
                  </div>

                  {/* Email */}
                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-[#0B1F3B] mb-2">
                      Email (Opsional)
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#FF8A00] focus:ring-2 focus:ring-[#FF8A00]/20 outline-none transition-all text-sm"
                      placeholder="email@example.com"
                    />
                  </div>

                  {/* Service */}
                  <div>
                    <label htmlFor="service" className="block text-sm font-semibold text-[#0B1F3B] mb-2">
                      Jenis Layanan <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                      required
                      className="w-full px-4 py-3 pr-8 rounded-xl border border-gray-300 focus:border-[#FF8A00] focus:ring-2 focus:ring-[#FF8A00]/20 outline-none transition-all text-sm cursor-pointer"
                    >
                      <option value="">Pilih layanan</option>
                      {services.map((service) => (
                        <option key={service} value={service}>{service}</option>
                      ))}
                    </select>
                  </div>

                  {/* Date */}
                  <div>
                    <label htmlFor="date" className="block text-sm font-semibold text-[#0B1F3B] mb-2">
                      Tanggal <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      id="date"
                      name="date"
                      value={formData.date}
                      onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                      required
                      min={new Date(Date.now() + 86400000).toISOString().split('T')[0]}
                      className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#FF8A00] focus:ring-2 focus:ring-[#FF8A00]/20 outline-none transition-all text-sm cursor-pointer"
                    />
                  </div>

                  {/* Time */}
                  <div>
                    <label htmlFor="time" className="block text-sm font-semibold text-[#0B1F3B] mb-2">
                      Waktu <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="time"
                      name="time"
                      value={formData.time}
                      onChange={(e) => setFormData({ ...formData, time: e.target.value })}
                      required
                      className="w-full px-4 py-3 pr-8 rounded-xl border border-gray-300 focus:border-[#FF8A00] focus:ring-2 focus:ring-[#FF8A00]/20 outline-none transition-all text-sm cursor-pointer"
                    >
                      <option value="">Pilih waktu</option>
                      {timeSlots.map((slot) => (
                        <option key={slot} value={slot}>{slot}</option>
                      ))}
                    </select>
                  </div>

                  {/* Device */}
                  <div className="md:col-span-2">
                    <label htmlFor="device" className="block text-sm font-semibold text-[#0B1F3B] mb-2">
                      Merk/Tipe Perangkat (Jika servis elektronik)
                    </label>
                    <input
                      type="text"
                      id="device"
                      name="device"
                      value={formData.device}
                      onChange={(e) => setFormData({ ...formData, device: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#FF8A00] focus:ring-2 focus:ring-[#FF8A00]/20 outline-none transition-all text-sm"
                      placeholder="Contoh: Asus ROG Strix G15, iPhone 13 Pro"
                    />
                  </div>

                  {/* Problem */}
                  <div className="md:col-span-2">
                    <label htmlFor="problem" className="block text-sm font-semibold text-[#0B1F3B] mb-2">
                      Deskripsi Masalah/Kebutuhan
                    </label>
                    <textarea
                      id="problem"
                      name="problem"
                      value={formData.problem}
                      onChange={(e) => setFormData({ ...formData, problem: e.target.value })}
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#FF8A00] focus:ring-2 focus:ring-[#FF8A00]/20 outline-none transition-all resize-none text-sm"
                      placeholder="Jelaskan masalah atau kebutuhan Anda..."
                    ></textarea>
                    <p className="text-xs text-gray-500 mt-1">
                      {formData.problem.length}/500 karakter
                    </p>
                  </div>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="mt-8 w-full bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] hover:from-[#0d2847] hover:to-[#0B1F3B] text-white py-4 rounded-xl font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-3 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line text-xl animate-spin"></i>
                      Mengirim Booking...
                    </>
                  ) : (
                    <>
                      <i className="ri-calendar-check-fill text-xl"></i>
                      Kirim Booking
                    </>
                  )}
                </button>

                {submitStatus === 'success' && (
                  <div className="mt-6 bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-xl flex items-center gap-3">
                    <i className="ri-check-line text-xl"></i>
                    <span className="text-sm">Booking berhasil dikirim! Kami akan konfirmasi via WhatsApp segera.</span>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="mt-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl flex items-center gap-3">
                    <i className="ri-error-warning-line text-xl"></i>
                    <span className="text-sm">Terjadi kesalahan. Silakan coba lagi atau hubungi kami via WhatsApp.</span>
                  </div>
                )}
              </form>
            </div>

            {/* Quick Contact */}
            <div className="mt-8 bg-orange-50 border-2 border-[#FF8A00] rounded-2xl p-6">
              <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#FF8A00] rounded-xl flex-shrink-0">
                    <i className="ri-customer-service-2-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-[#0B1F3B] text-lg">Butuh Bantuan?</h3>
                    <p className="text-gray-600 text-sm">Hubungi kami langsung untuk konsultasi</p>
                  </div>
                </div>
                <a
                  href="https://wa.me/6285868360910"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#25D366] hover:bg-[#20bd5a] text-white px-6 py-3 rounded-xl font-semibold transition-all flex items-center gap-2 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-fill text-xl"></i>
                  Chat WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}